import { Stack, Tooltip } from '@mui/material';
import { TenantDTO } from 'probonio-shared-ui/api';
import { Trans, useTranslation } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';
import { getBenefitIcon } from '../../BenefitIcon';
import { NonCashBenefit } from '../../nonCashBenefit/const';

export const NonCashIcon: React.FC<{ nonCashBenefit: NonCashBenefit }> = ({ nonCashBenefit }) => {
  const { t } = useTranslation('benefitsModule');
  const Icon = getBenefitIcon(nonCashBenefit);
  return (
    <Tooltip title={t(`nonCashBenefits.${nonCashBenefit}.name`)}>
      <Icon fontSize="small" color="primary" />
    </Tooltip>
  );
};

export class CouponsBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: (context?: { tenant?: TenantDTO }) => BenefitAttribute[] = context => [
    {
      id: 'couponsMonthlyBudget',
      accessorFn: value => value.couponsOptions?.monthlyBudget,
      header: 'COUPONS.fields.monthlyBudget',
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
    ...((context?.tenant?.nonCashBenefits?.length ?? 0) > 1
      ? [
          {
            id: 'nonCashBenefits',
            accessorFn: value => value.couponsOptions?.nonCashBenefits,
            header: 'employeeTabs.header.nonCashBenefits',
            renderer: value =>
              value ? (
                <Stack direction="row" alignItems="center">
                  {(value as NonCashBenefit[]).map(val => (
                    <NonCashIcon nonCashBenefit={val} key={val} />
                  ))}
                </Stack>
              ) : null,
          } satisfies BenefitAttribute,
        ]
      : []),
  ];
}
